/**
 * GoalOverlay - FC-style "GOAL!" celebration flash shown when a goal is scored.
 */

import * as GUI from "babylonjs-gui";

export class GoalOverlay {
  private _texture: GUI.AdvancedDynamicTexture;
  private _container: GUI.Rectangle;
  private _goalText: GUI.TextBlock;
  private _scorerText: GUI.TextBlock;
  private _timer = 0;

  constructor() {
    this._texture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("goalOverlay");

    this._container = new GUI.Rectangle("goalBg");
    this._container.width = "100%";
    this._container.height = "100%";
    this._container.thickness = 0;
    this._container.background = "transparent";
    this._container.isVisible = false;
    this._texture.addControl(this._container);

    this._goalText = new GUI.TextBlock("goalText", "⚽ GOAL!");
    this._goalText.color = "#00ff88";
    this._goalText.fontSize = 120;
    this._goalText.fontWeight = "900";
    this._goalText.fontFamily = "Orbitron, sans-serif";
    this._goalText.outlineWidth = 6;
    this._goalText.outlineColor = "black";
    this._goalText.top = "-40px";
    this._container.addControl(this._goalText);

    this._scorerText = new GUI.TextBlock("scorerText", "YOU SCORED!");
    this._scorerText.color = "white";
    this._scorerText.fontSize = 32;
    this._scorerText.fontWeight = "700";
    this._scorerText.fontFamily = "Orbitron, sans-serif";
    this._scorerText.outlineWidth = 3;
    this._scorerText.outlineColor = "black";
    this._scorerText.top = "60px";
    this._container.addControl(this._scorerText);
  }

  show(side: "player" | "opponent"): void {
    this._container.isVisible = true;
    this._timer = 3.0;
    this._goalText.scaleX = 0.5;
    this._goalText.scaleY = 0.5;

    if (side === "player") {
      this._goalText.text = "⚽ GOAL!";
      this._goalText.color = "#00ff88";
      this._scorerText.text = "FANTASTIC FINISH!";
    } else {
      this._goalText.text = "⚽ CONCEDED";
      this._goalText.color = "#ff3366";
      this._scorerText.text = "OPPONENT SCORED";
    }
  }

  update(dt: number): void {
    if (this._timer <= 0) return;
    this._timer -= dt;

    // Simple scale up animation
    if (this._timer > 2.5) {
        const p = (3.0 - this._timer) / 0.5;
        this._goalText.scaleX = 0.5 + p * 0.6; // Scale to 1.1
        this._goalText.scaleY = 0.5 + p * 0.6;
    } else {
        // Subtle pulse
        const pulse = Math.sin(this._timer * 10) * 0.05;
        this._goalText.scaleX = 1.0 + pulse;
        this._goalText.scaleY = 1.0 + pulse;
    }

    // Fade out in last second
    if (this._timer < 1) {
      const alpha = this._timer;
      this._goalText.alpha = alpha;
      this._scorerText.alpha = alpha;
      this._container.background = `rgba(0,0,0,${alpha * 0.4})`;
    } else {
      this._goalText.alpha = 1;
      this._scorerText.alpha = 1;
      this._container.background = "rgba(0,0,0,0.4)";
    }

    if (this._timer <= 0) {
      this._container.isVisible = false;
    }
  }

  dispose(): void {
    this._texture.dispose();
  }
}
